export enum BaseErrorStatus {
  BadRequest = 'BAD_REQUEST',
  FailedTooManyCalls = 'FAILED_TOO_MANY_CALLS',
  FailedUnexpected = 'FAILED_UNEXPECTED',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  MalformedInputData = 'MALFORMED_INPUT_DATA',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
}
